// extracted by mini-css-extract-plugin
export default {"back":"confirm-btn_back__Q+nLA"};